import Button from 'coreOld/components/Button';
import { Checkbox } from 'coreOld/elements';
import { ButtonType, Size } from 'coreOld/enums';
import { IPill } from 'partsOld/types';

import {
  ButtonWrapper,
  CheckboxesWrapper,
  Column,
  List,
  ListWrapper,
  Space,
  Wrapper,
} from './pillListStyle';
import { Pill } from '../dragAndDrop';

interface IProps {
  initialPills: IPill[];
  clearHeaders: () => void;
  onCheckboxChange: (isPricing: boolean) => void;
  quantityCheckbox: boolean;
  pricingCheckbox: boolean;
  onConfirmMapping: () => Promise<void>;
  isLoading: boolean;
}

const PillListView = ({
  initialPills,
  clearHeaders,
  onCheckboxChange,
  pricingCheckbox,
  quantityCheckbox,
  onConfirmMapping,
}: IProps) => {
  return (
    <Wrapper>
      <ListWrapper>
        <List>{initialPills?.map((item) => <Pill key={item.id} pill={item} />)}</List>

        <Column>
          <Checkbox label="Merge duplicate parts" disabled={true} checked />

          <ButtonWrapper>
            <Button onClick={clearHeaders} size={Size.SM} btnType={ButtonType.ACTION_INVERTED}>
              Clear Headers
            </Button>
          </ButtonWrapper>

          <ButtonWrapper>
            <Button onClick={onConfirmMapping} size={Size.SM}>
              Confirm Mapping
            </Button>
          </ButtonWrapper>
        </Column>
      </ListWrapper>

      <CheckboxesWrapper>
        <Checkbox
          checked={quantityCheckbox}
          label="Import quantity discounts"
          onChange={() => onCheckboxChange(false)}
        />

        <Space />

        <Checkbox
          checked={pricingCheckbox}
          label="Import pricing groups"
          onChange={() => onCheckboxChange(true)}
        />
      </CheckboxesWrapper>
    </Wrapper>
  );
};

export default PillListView;
